  /* ============================================================
    IMAGE CUSTOMIZER PATCH v5
    - View In Room: draggable, multi-frame overlay (place anywhere)
    - Tear Sheet:   PDF download with or without pricing (menu on click)
    ============================================================ */

  /* ── Load jsPDF from CDN ── */
  (function loadJsPDF() {
    if (window.jspdf) return;
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
    document.head.appendChild(s);
  })();

  /* ============================================================
    UTILITY: load any URL → { dataUrl, width, height } or null
    ============================================================ */
  function loadImgInfo(url) {
    if (!url) return Promise.resolve(null);

    function measureDataUrl(dataUrl) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload  = function () { resolve({ dataUrl: dataUrl, width: img.naturalWidth || 1, height: img.naturalHeight || 1 }); };
        img.onerror = function () { resolve({ dataUrl: dataUrl, width: 400, height: 400 }); };
        img.src = dataUrl;
      });
    }

    if (url.indexOf('data:') === 0) return measureDataUrl(url);

    return fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.blob(); })
      .then(function (blob) {
        return new Promise(function (resolve, reject) {
          var fr = new FileReader();
          fr.onload  = function () { resolve(fr.result); };
          fr.onerror = reject;
          fr.readAsDataURL(blob);
        });
      })
      .then(measureDataUrl)
      .catch(function () {
        return new Promise(function (resolve) {
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            try {
              var c = document.createElement('canvas');
              c.width = img.naturalWidth; c.height = img.naturalHeight;
              c.getContext('2d').drawImage(img, 0, 0);
              resolve({ dataUrl: c.toDataURL('image/png'), width: img.naturalWidth, height: img.naturalHeight });
            } catch (e) { resolve(null); }
          };
          img.onerror = function () { resolve(null); };
          img.src = url;
        });
      });
  }

  /* ============================================================
    READ SUMMARY DATA (state-first, DOM fallback)
    ============================================================ */
  function readSummaryFromState() {
    var customizer = document.querySelector('.image-customizer-popup:not([hidden]) .customizer') ||
      document.querySelector('.customizer');
    if (customizer && typeof window.syncCustomizerSelectionsFromDOM === 'function') {
      window.syncCustomizerSelectionsFromDOM(customizer);
    }
    var st = window.customizerState || {};
    function fmtEntity(e) {
      if (!e) return '';
      var id = e.id || '';
      var name = e.name || '';
      if (id && name) return id + ' ' + name;
      return id || name || '';
    }
    var treatment = st.treatment || '';
    var showMats = (treatment === 'Single Mat' || treatment === 'Double Mat');
    var showBottom = (treatment === 'Double Mat');
    return {
      substrate:        st.substrate || '',
      treatment:        treatment,
      width:            st.width != null ? String(st.width) : '',
      height:           st.height != null ? String(st.height) : '',
      designApproved:   !!st.designApproved,
      frame:            fmtEntity(st.frame),
      topMat:           showMats ? fmtEntity(st.topMat) : '',
      bottomMat:        showBottom ? fmtEntity(st.bottomMat) : '',
      liner:            fmtEntity(st.liner),
      artworkColor:     st.artworkColor ? (st.artworkColor.name || 'Custom') : '',
      colorInstruction: st.colorInstruction || '',
      customTextEnabled: !!st.customTextEnabled,
      customerNotes:    st.customerNotes || '',
      imageText:          st.imageText || '',
      sideMark:         !!st.sideMark,
      sideMarkText:     st.sideMarkText || ''
    };
  }

  /* ============================================================
    VIEW IN ROOM — draggable multi-frame overlay
    ============================================================ */
  function patchViewInRoom() {
    function getFramedArtworkDataURL() {
      var fsCanvas = document.getElementById('fs-canvas');
      if (fsCanvas && fsCanvas.width > 10) {
        try { return fsCanvas.toDataURL('image/png'); } catch (e) {}
      }
      if (typeof window.__fsGetCanvasDataURL === 'function') {
        var url = window.__fsGetCanvasDataURL();
        if (url) return url;
      }
      var customizer = document.querySelector('.image-customizer-popup:not([hidden]) .customizer') ||
        document.querySelector('.customizer');
      var img = customizer
        ? customizer.querySelector('.editable-image')
        : document.querySelector('.editable-image');
      if (img) return img.dataset.framedSrc || img.src;
      return null;
    }

    function getProductArtworkUrl(popup) {
      if (popup && popup.dataset.virProductImage) return popup.dataset.virProductImage;
      if (typeof window.__fsFeaturedProductImg === 'string' && window.__fsFeaturedProductImg) {
        return window.__fsFeaturedProductImg;
      }
      var galleryImg = document.querySelector(
        '.productView-image img, .product__media-item img, .product-single__media img, ' +
        '[data-product-featured-image], .product-media-container img, .product__media img'
      );
      if (galleryImg && galleryImg.src && !String(galleryImg.src).startsWith('data:')) {
        return galleryImg.currentSrc || galleryImg.src;
      }
      return null;
    }

    function getViewInRoomArtworkSrc(popup) {
      var source = popup && popup.dataset.virArtworkSource
        ? popup.dataset.virArtworkSource
        : 'product';
      if (source === 'customizer') return getFramedArtworkDataURL();
      return getProductArtworkUrl(popup);
    }

    function prepareViewInRoomPopup(popup, openBtn) {
      if (!popup) return;
      var source = openBtn && openBtn.getAttribute('data-vir-artwork');
      if (!source) {
        source = openBtn && openBtn.closest('.customizer') ? 'customizer' : 'product';
      }
      popup.dataset.virArtworkSource = source;

      if (source === 'product') {
        var productUrl = (openBtn && (
          openBtn.getAttribute('data-vir-product-image') ||
          openBtn.getAttribute('data-product-image')
        )) || '';
        if (productUrl) popup.dataset.virProductImage = productUrl;
      } else {
        delete popup.dataset.virProductImage;
      }

      var overlay = popup.querySelector('[data-vir-overlay]');
      if (overlay) overlay.innerHTML = '';
      popup.__virAutoAdded = false;
    }

    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    function makeDraggable(frameEl, stage) {
      var dragging   = false;
      var resizing   = false;
      var startX, startY, startLeft, startTop;
      var startW, startH, aspect;
      var stageHost = stage.closest('[data-vir-stage]') || stage;

      function setFramePosition(left, top) {
        frameEl.style.left = left + 'px';
        frameEl.style.top = top + 'px';
        /* translate3d keeps drag on its own layer — avoids iOS Safari blurring the room image */
        frameEl.style.transform = 'translate3d(0, 0, 0)';
      }

      function onPointerDown(e) {
        if (e.target.classList.contains('vir-frame__close')) return;
        e.preventDefault();
        stage.querySelectorAll('.vir-frame--selected').forEach(function (el) {
          el.classList.remove('vir-frame--selected');
        });
        frameEl.classList.add('vir-frame--selected');

        var resizeHandle = e.target.classList.contains('vir-frame__resize');
        startX = e.clientX; startY = e.clientY;
        startLeft = parseFloat(frameEl.style.left) || 0;
        startTop  = parseFloat(frameEl.style.top)  || 0;
        startW    = frameEl.offsetWidth;
        startH    = frameEl.offsetHeight;
        /* virAspect is height ÷ width (matches applyProportionalFrameSize). */
        aspect    = parseFloat(frameEl.dataset.virAspect);
        if (!isFinite(aspect) || aspect <= 0) {
          aspect = startH / Math.max(1, startW);
        }

        if (resizeHandle) {
          resizing = true;
          stageHost.classList.add('vir-stage--dragging');
        } else {
          dragging = true;
          frameEl.classList.add('vir-frame--dragging');
          stageHost.classList.add('vir-stage--dragging');
        }
        window.addEventListener('pointermove', onPointerMove, { passive: false });
        window.addEventListener('pointerup', onPointerUp, { once: true });
        window.addEventListener('pointercancel', onPointerUp, { once: true });
      }

      function onPointerMove(e) {
        if (dragging || resizing) e.preventDefault();
        var stageRect = stage.getBoundingClientRect();
        if (dragging) {
          var dx = e.clientX - startX;
          var dy = e.clientY - startY;
          var nx = clamp(startLeft + dx, -frameEl.offsetWidth * 0.3, stageRect.width - frameEl.offsetWidth * 0.7);
          var ny = clamp(startTop  + dy, -frameEl.offsetHeight * 0.3, stageRect.height - frameEl.offsetHeight * 0.7);
          setFramePosition(nx, ny);
        } else if (resizing) {
          var dw = e.clientX - startX;
          var newW = clamp(startW + dw, 60, stageRect.width * 0.9);
          var newH = Math.round(newW * aspect);
          var maxH = stageRect.height * 0.9;
          if (newH > maxH) {
            newH = Math.round(maxH);
            newW = Math.round(newH / aspect);
          }
          frameEl.style.width  = newW + 'px';
          frameEl.style.height = newH + 'px';
        }
      }

      function onPointerUp() {
        dragging = false;
        resizing = false;
        frameEl.classList.remove('vir-frame--dragging');
        stageHost.classList.remove('vir-stage--dragging');
        window.removeEventListener('pointermove', onPointerMove);
      }

      frameEl.addEventListener('pointerdown', onPointerDown, { passive: false });
    }

    function getFramedArtworkAspectRatio() {
      var fsCanvas = document.getElementById('fs-canvas');
      if (fsCanvas && fsCanvas.width > 10 && fsCanvas.height > 10) {
        return fsCanvas.height / Math.max(1, fsCanvas.width);
      }
      return null;
    }

    function loadImageForCanvas(src) {
      return new Promise(function (resolve, reject) {
        if (!src) {
          reject(new Error('Missing image source'));
          return;
        }
        var img = new Image();
        if (!String(src).startsWith('data:')) {
          img.crossOrigin = 'anonymous';
        }
        img.onload = function () { resolve(img); };
        img.onerror = function () { reject(new Error('Image failed to load')); };
        img.src = src;
      });
    }

    function applyProportionalFrameSize(frameEl, artworkImg, widthPx) {
      var w = Math.max(40, widthPx || frameEl.offsetWidth || 120);
      var ratio = getFramedArtworkAspectRatio();
      if (!ratio && artworkImg && artworkImg.naturalWidth > 0) {
        ratio = artworkImg.naturalHeight / Math.max(1, artworkImg.naturalWidth);
      }
      if (!ratio || !isFinite(ratio) || ratio <= 0) ratio = 0.75;
      var h = Math.round(w * ratio);
      frameEl.style.width = w + 'px';
      frameEl.style.height = h + 'px';
      frameEl.dataset.virAspect = String(ratio);
      frameEl.dataset.virInitialWidth = String(w);
      frameEl.dataset.virInitialHeight = String(h);
      return { width: w, height: h };
    }

    function createFrameEl(stage, artworkSrc, opts) {
      opts = opts || {};
      var stageRect = stage.getBoundingClientRect();
      if (!stageRect || stageRect.width < 50 || stageRect.height < 50) {
        var host = stage.closest('[data-vir-stage]') || stage.parentElement;
        if (host) stageRect = host.getBoundingClientRect();
      }

      var measureImg = new Image();
      if (!String(artworkSrc).startsWith('data:')) {
        measureImg.crossOrigin = 'anonymous';
      }
      measureImg.src = artworkSrc;

      var frameEl = document.createElement('div');
      frameEl.className = 'vir-frame';

      var w = opts.width || Math.round(stageRect.width * 0.22);
      var x = opts.left != null ? opts.left : Math.round((stageRect.width - w) / 2);
      var y = opts.top  != null ? opts.top  : Math.round(stageRect.height * 0.18);

      frameEl.style.left   = x + 'px';
      frameEl.style.top    = y + 'px';
      frameEl.style.width  = w + 'px';

      frameEl.dataset.virInitialLeft  = String(x);
      frameEl.dataset.virInitialTop   = String(y);
      frameEl.dataset.virInitialWidth = String(w);

      var imgEl = document.createElement('img');
      imgEl.alt = 'Framed artwork';
      imgEl.src = artworkSrc;
      if (!String(artworkSrc).startsWith('data:')) {
        imgEl.crossOrigin = 'anonymous';
      }
      imgEl.style.width = '100%';
      imgEl.style.height = '100%';
      imgEl.style.objectFit = 'contain';

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'vir-frame__close';
      closeBtn.setAttribute('aria-label', 'Remove this frame');
      closeBtn.textContent = '×';

      var resizeHandle = document.createElement('div');
      resizeHandle.className = 'vir-frame__resize';
      resizeHandle.setAttribute('aria-label', 'Resize frame');

      frameEl.appendChild(imgEl);
      frameEl.appendChild(closeBtn);
      frameEl.appendChild(resizeHandle);
      stage.appendChild(frameEl);

      function syncSize() {
        applyProportionalFrameSize(frameEl, measureImg, w);
        frameEl.dataset.virInitialHeight = frameEl.style.height.replace('px', '');
        frameEl.style.visibility = '';
      }

      if (measureImg.complete) {
        syncSize();
      } else {
        frameEl.style.visibility = 'hidden';
        measureImg.onload = syncSize;
      }

      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        frameEl.remove();
      });

      makeDraggable(frameEl, stage);
      return frameEl;
    }

    function downloadViewInRoomPreview(popup) {
      var stageHost = popup.querySelector('[data-vir-stage]');
      var overlay = popup.querySelector('[data-vir-overlay]');
      var roomImgEl = stageHost ? stageHost.querySelector('.view-in-room-popup__image') : null;
      if (!stageHost || !overlay || !roomImgEl) return;

      var rect = stageHost.getBoundingClientRect();
      var canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(rect.width));
      canvas.height = Math.max(1, Math.round(rect.height));
      var ctx = canvas.getContext('2d');

      var frameEls = Array.from(overlay.querySelectorAll('.vir-frame'));

      function triggerDownload() {
        try {
          var link = document.createElement('a');
          link.download = 'view-in-room-preview.png';
          link.href = canvas.toDataURL('image/png');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } catch (e) {
          alert('Download failed. If images are hosted on another domain, try again after the preview fully loads.');
        }
      }

      function drawFrameImages(frameImages) {
        frameEls.forEach(function (frameEl, index) {
          var img = frameImages[index];
          if (!img) return;
          var left = parseFloat(frameEl.style.left) || 0;
          var top = parseFloat(frameEl.style.top) || 0;
          var fw = frameEl.offsetWidth;
          var fh = frameEl.offsetHeight;
          try {
            ctx.drawImage(img, left, top, fw, fh);
          } catch (e) {}
        });
        triggerDownload();
      }

      function drawRoomThenFrames(roomImg) {
        try {
          ctx.drawImage(roomImg, 0, 0, canvas.width, canvas.height);
        } catch (e) {
          ctx.fillStyle = '#f2f2f2';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
        }

        var frameSrcs = frameEls.map(function (frameEl) {
          var artImg = frameEl.querySelector('img');
          return artImg ? (artImg.currentSrc || artImg.src) : '';
        }).filter(Boolean);

        if (!frameSrcs.length) {
          triggerDownload();
          return;
        }

        Promise.all(frameSrcs.map(function (src) { return loadImageForCanvas(src); }))
          .then(drawFrameImages)
          .catch(function () {
            frameEls.forEach(function (frameEl) {
              var artImg = frameEl.querySelector('img');
              if (!artImg) return;
              var left = parseFloat(frameEl.style.left) || 0;
              var top = parseFloat(frameEl.style.top) || 0;
              try {
                ctx.drawImage(artImg, left, top, frameEl.offsetWidth, frameEl.offsetHeight);
              } catch (e) {}
            });
            triggerDownload();
          });
      }

      loadImageForCanvas(roomImgEl.currentSrc || roomImgEl.src)
        .then(function (roomImg) { drawRoomThenFrames(roomImg); })
        .catch(function () {
          ctx.fillStyle = '#f2f2f2';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          drawRoomThenFrames(roomImgEl);
        });
    }

    function restoreFrameDefaults(frameEl) {
      if (!frameEl) return;

      var left = parseFloat(frameEl.dataset.virInitialLeft || '');
      var top  = parseFloat(frameEl.dataset.virInitialTop || '');
      var w    = parseFloat(frameEl.dataset.virInitialWidth || '');
      if (!isFinite(left) || !isFinite(top) || !isFinite(w)) return;

      frameEl.style.left  = left + 'px';
      frameEl.style.top   = top + 'px';
      frameEl.style.width = w + 'px';

      var h = parseFloat(frameEl.dataset.virInitialHeight || '');
      if (isFinite(h)) frameEl.style.height = h + 'px';

      frameEl.classList.remove('vir-frame--selected');
    }

    /* When the popup becomes visible, ensure a default frame appears automatically. */
    function autoAddFirstFrame(popup) {
      var stage   = popup.querySelector('[data-vir-stage]');
      var overlay = popup.querySelector('[data-vir-overlay]');
      if (!stage || !overlay) return;

      if (overlay.querySelector('.vir-frame')) return;
      if (popup.__virAutoAdded) return;
      popup.__virAutoAdded = true;

      var attempts = 0;
      function tryClick() {
        if (overlay.querySelector('.vir-frame')) return;
        var rect = stage.getBoundingClientRect();
        var ready = !popup.hidden && rect.width > 50 && rect.height > 50 && getViewInRoomArtworkSrc(popup);
        if (!ready) {
          if (++attempts > 120) return;
          setTimeout(tryClick, 80);
          return;
        }
        var roomImg = stage.querySelector('.view-in-room-popup__image');
        function addNow() {
          if (overlay.querySelector('.vir-frame')) return;
          var artworkSrc = getViewInRoomArtworkSrc(popup);
          if (!artworkSrc) return;
          createFrameEl(overlay, artworkSrc);
        }
        if (roomImg && !roomImg.complete) {
          roomImg.addEventListener('load', function () {
            addNow();
          }, { once: true });
        } else {
          addNow();
        }
      }
      tryClick();
    }

    /* Watch every view-in-room popup so the auto-click fires no matter
      how the popup is opened (click delegation, programmatic, etc.). */
    function watchViewInRoomPopups() {
      var popups = document.querySelectorAll('.image-customizer-popup--view-in-room');
      popups.forEach(function (popup) {
        if (popup.__virObserved) return;
        popup.__virObserved = true;
        if (!popup.hidden) autoAddFirstFrame(popup);
        var mo = new MutationObserver(function () {
          if (popup.hidden) {
            popup.__virAutoAdded = false;
          } else {
            autoAddFirstFrame(popup);
          }
        });
        mo.observe(popup, { attributes: true, attributeFilter: ['hidden'] });
      });
    }
    watchViewInRoomPopups();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchViewInRoomPopups);
    }
    setTimeout(watchViewInRoomPopups, 1000);

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-open-popup]');
      if (openBtn) {
        var popupId = openBtn.getAttribute('data-open-popup');
        if (!popupId || !popupId.includes('view-in-room')) return;
        var popup = document.getElementById(popupId);
        if (popup) {
          prepareViewInRoomPopup(popup, openBtn);
          autoAddFirstFrame(popup);
        }
        return;
      }

      var resetBtn = e.target.closest('.vir-reset');
      if (resetBtn) {
        var popup2 = resetBtn.closest('.image-customizer-popup--view-in-room');
        if (!popup2) return;
        var overlay2 = popup2.querySelector('[data-vir-overlay]');
        if (!overlay2) return;
        overlay2.querySelectorAll('.vir-frame').forEach(function (frameEl) {
          restoreFrameDefaults(frameEl);
        });
        return;
      }

      var downloadBtn = e.target.closest('.vir-download');
      if (downloadBtn) {
        var popup3 = downloadBtn.closest('.image-customizer-popup--view-in-room');
        if (popup3) downloadViewInRoomPreview(popup3);
        return;
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.vir-frame')) {
        document.querySelectorAll('.vir-frame--selected').forEach(function (el) {
          el.classList.remove('vir-frame--selected');
        });
      }
    });
  }

  /* ============================================================
    TEAR SHEET — FULLY ASYNC
    ============================================================ */
  var __tearSheetInFlight = false;

  function readTearSheetPricing(includePricing) {
    if (!includePricing) return null;
    if (typeof window.getTearSheetPricingRows !== 'function') return null;
    var customizer = document.querySelector('.image-customizer-popup:not([hidden]) .customizer') ||
      document.querySelector('.customizer');
    return window.getTearSheetPricingRows(customizer);
  }

  function generateTearSheet(includePricing) {
    if (__tearSheetInFlight) return;
    if (!window.jspdf) {
      alert('PDF library is still loading — please try again in a moment.');
      return;
    }

    var wantPricing = !!includePricing;
    var pricingData = readTearSheetPricing(wantPricing);
    if (wantPricing && (!pricingData || !pricingData.available)) {
      if (pricingData && !pricingData.available) {
        alert('Pricing is available for logged-in customers only. Downloading tear sheet without pricing.');
      }
      wantPricing = false;
      pricingData = null;
    }

    __tearSheetInFlight = true;

    /* Collect text data synchronously */
    var summaryData  = readSummaryFromState();
    var productTitle = '';
    var summaryStep = (typeof window.getSummaryStep === 'function' && window.getSummaryStep()) || 5;
    var titleEl = document.querySelector('.step-panel[data-step="' + summaryStep + '"] .summary-title-text') ||
                  document.querySelector('.step-panel[data-role="summary"] .summary-title-text') ||
                  document.querySelector('.customizer-steps-title');
    if (titleEl) productTitle = titleEl.textContent.trim();
    if (!productTitle || productTitle === 'Configuration Summary') {
      productTitle = document.title.replace(/\s*[\|\-–]\s*.*$/, '').trim() || 'Artwork';
    }

    var sku = '';
    var skuNumEl = document.querySelector('.customizer-steps-inv__number');
    var skuEl = skuNumEl || document.querySelector('.customizer-steps-inv') || document.querySelector('.customizer-steps-sku');
    if (skuNumEl) sku = skuNumEl.textContent.trim();
    else if (skuEl) sku = skuEl.textContent.replace(/^\s*(?:SKU|Inv)#?:\s*/i, '').trim();

    var websiteUrl = window.location.hostname || 'www.yourstore.com';

    /* Artwork source */
    var artworkSrc = null;
    var fsCanvas   = document.getElementById('fs-canvas');
    if (fsCanvas && fsCanvas.width > 10) {
      try { artworkSrc = fsCanvas.toDataURL('image/png'); } catch (e) {}
    }
    if (!artworkSrc && typeof window.__fsGetCanvasDataURL === 'function') {
      try { artworkSrc = window.__fsGetCanvasDataURL(); } catch (e) {}
    }
    if (!artworkSrc) {
      var imgEls = document.querySelectorAll('.editable-image');
      for (var i = 0; i < imgEls.length; i++) {
        var s = imgEls[i].dataset.framedSrc || imgEls[i].getAttribute('src') || '';
        if (s) { artworkSrc = s; break; }
      }
    }

    /* Frame thumbnail + dimension diagram */
    var frameThumbSrc = null, frameDimSrc = null;
    var st = window.customizerState || {};
    if (st.frame) {
      frameThumbSrc = st.frame.img || st.frame.thumb || null;
      frameDimSrc   = st.frame.dim || null;
      if (!frameThumbSrc && st.frame.id && Array.isArray(window.FRAMES)) {
        var ref = window.FRAMES.find(function (f) { return f.id === st.frame.id; });
        if (ref) { frameThumbSrc = ref.thumb || ref.img || null; frameDimSrc = frameDimSrc || ref.dim || null; }
      }
    }

    var LOGO_URL = 'https://iconicpineapple.com/cdn/shop/files/imgi_1_logo.png?v=1751505111';

    /* Load all images in parallel, then build PDF */
    Promise.all([
      loadImgInfo(LOGO_URL),
      loadImgInfo(artworkSrc),
      loadImgInfo(frameThumbSrc),
      loadImgInfo(frameDimSrc)
    ]).then(function (results) {
      buildAndSavePDF({
        logoInfo:     results[0],
        artworkInfo:  results[1],
        frameInfo:    results[2],
        frameDimInfo: results[3],
        summaryData:  summaryData,
        productTitle: productTitle,
        sku:          sku,
        websiteUrl:   websiteUrl,
        includePricing: wantPricing,
        pricingData:  pricingData
      });
    }).catch(function (err) {
      console.error('[TearSheet] load error:', err);
      buildAndSavePDF({
        logoInfo: null, artworkInfo: null, frameInfo: null, frameDimInfo: null,
        summaryData: summaryData, productTitle: productTitle, sku: sku, websiteUrl: websiteUrl,
        includePricing: wantPricing,
        pricingData: pricingData
      });
    }).finally(function () {
      setTimeout(function () { __tearSheetInFlight = false; }, 600);
    });
  }

  /* ============================================================
    BUILD PDF — called only after all images are loaded
    ============================================================ */
  function buildAndSavePDF(opts) {
    var logoInfo     = opts.logoInfo;
    var artworkInfo  = opts.artworkInfo;
    var frameInfo    = opts.frameInfo;
    var frameDimInfo = opts.frameDimInfo;
    var d            = opts.summaryData;
    var productTitle = opts.productTitle;
    var sku          = opts.sku;
    var websiteUrl   = opts.websiteUrl;
    var includePricing = !!opts.includePricing;
    var pricingData  = opts.pricingData || null;

    var jsPDF = window.jspdf.jsPDF;
    var doc   = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    var PW = 297, PH = 210, margin = 12;
    var BLACK = [20, 20, 20], GREY = [130, 130, 130], LGREY = [220, 220, 220];

    function setDraw(c) { doc.setDrawColor(c[0], c[1], c[2]); }
    function setFill(c) { doc.setFillColor(c[0], c[1], c[2]); }
    function setTxt(c)  { doc.setTextColor(c[0], c[1], c[2]); }

    function addImg(info, x, y, w, h) {
      if (!info || !info.dataUrl) return;
      try {
        var fmt = info.dataUrl.indexOf('data:image/png') === 0 ? 'PNG' : 'JPEG';
        doc.addImage(info.dataUrl, fmt, x, y, w, h);
      } catch (e) { console.warn('[TearSheet] addImage error', e); }
    }

    function fitTop(info, bx, by, bw, bh, pad) {
      if (!info || !info.dataUrl) return;
      pad = pad || 0;
      var maxW = bw - pad * 2, maxH = bh - pad * 2;
      var iw = info.width || maxW, ih = info.height || maxH;
      var sc = Math.min(maxW / iw, maxH / ih);
      var dw = iw * sc, dh = ih * sc;
      var dx = bx + pad + (maxW - dw) / 2;
      var dy = by + pad;
      addImg(info, dx, dy, dw, dh);
    }

    function fitCenter(info, bx, by, bw, bh, pad) {
      if (!info || !info.dataUrl) return;
      pad = pad || 0;
      var maxW = bw - pad * 2, maxH = bh - pad * 2;
      var iw = info.width || maxW, ih = info.height || maxH;
      var sc = Math.min(maxW / iw, maxH / ih);
      var dw = iw * sc, dh = ih * sc;
      var dx = bx + pad + (maxW - dw) / 2;
      var dy = by + pad + (maxH - dh) / 2;
      addImg(info, dx, dy, dw, dh);
    }

    /* White background */
    setFill([255, 255, 255]); doc.rect(0, 0, PW, PH, 'F');

    /* ── HEADER ── */
    var headerH = 28;
    setDraw(LGREY); doc.setLineWidth(0.4);
    doc.line(margin, headerH, PW - margin, headerH);

    var lbx = margin, lby = 6, lbw = 52, lbh = 16;
    if (logoInfo && logoInfo.dataUrl) {
      fitCenter(logoInfo, lbx, lby, lbw, lbh, 1);
    } else {
      setDraw(LGREY); doc.setLineWidth(0.3); doc.rect(lbx, lby, lbw, lbh);
      doc.setFontSize(7); setTxt(GREY);
      doc.text('YOUR LOGO HERE', lbx + lbw / 2, lby + lbh / 2 + 1, { align: 'center' });
    }

    var titleAreaX = margin + 58;
    var titleAreaW = PW - margin - titleAreaX;
    if (sku) {
      doc.setFontSize(16); setTxt(BLACK); doc.setFont(undefined, 'bold');
      doc.text('INV# ' + String(sku), titleAreaX + titleAreaW / 2, 10, { align: 'center' });
    }
    doc.setFontSize(11); setTxt(BLACK); doc.setFont(undefined, 'bold');
    doc.text(String(productTitle).toUpperCase(), titleAreaX + titleAreaW / 2, sku ? 16 : 12, { align: 'center' });
    doc.setFont(undefined, 'normal'); doc.setFontSize(8); setTxt(GREY);
    doc.text('Product Specification Sheet', titleAreaX + titleAreaW / 2, sku ? 22 : 18, { align: 'center' });

    /* ── LEFT COLUMN: artwork (TOP aligned) ── */
    var lx = margin, ly = headerH + 6, lw = 110, lh = PH - headerH - 24;
    setDraw(LGREY); doc.setLineWidth(0.3); doc.rect(lx, ly, lw, lh);

    if (artworkInfo && artworkInfo.dataUrl) {
      fitTop(artworkInfo, lx, ly, lw, lh, 6);
    } else {
      doc.setFontSize(9); setTxt(GREY);
      doc.text('Customized Artwork Preview', lx + lw / 2, ly + lh / 2, { align: 'center' });
    }

    /* ── RIGHT COLUMN ── */
    var rx = lx + lw + 10, rw = PW - rx - margin, ry = ly;
    var thumbSz = 34, thumbGap = 10, thumbRowH = thumbSz + 6;

    function drawThumbBox(info, bx, by, caption) {
      setDraw(LGREY); doc.setLineWidth(0.3); doc.rect(bx, by, thumbSz, thumbSz);
      if (info && info.dataUrl) {
        fitCenter(info, bx, by, thumbSz, thumbSz, 2);
      } else {
        doc.setFontSize(6.5); setTxt(GREY);
        doc.text(caption, bx + thumbSz / 2, by + thumbSz / 2 + 1, { align: 'center' });
      }
    }

    drawThumbBox(frameInfo, rx, ry, 'Frame');
    var dimThumb = (frameDimInfo && frameDimInfo.dataUrl &&
      (!frameInfo || !frameInfo.dataUrl || frameDimInfo.dataUrl !== frameInfo.dataUrl))
      ? frameDimInfo : null;
    drawThumbBox(dimThumb, rx + thumbSz + thumbGap, ry, 'Dimensions');

    /* ── SPEC ROWS (fixed label / value columns) ── */
    var LABEL_COL_W = 62;
    var lbX = rx;
    var vX = rx + LABEL_COL_W;
    var valueMaxW = rw - LABEL_COL_W;
    var sy = ry + thumbRowH + 8;
    var rowH = 7.5;

    function dash(v) { return (v && String(v).trim()) ? String(v).trim() : '\u2014'; }

    function formatDimPair(w, h) {
      if (!w || !h) return '\u2014';
      return String(w) + ' \xD7 ' + String(h) + ' in';
    }

    function formatComputedDim(fn) {
      if (typeof fn !== 'function') return '\u2014';
      var dims = fn();
      return (dims && dims.width && dims.height)
        ? formatDimPair(dims.width, dims.height)
        : '\u2014';
    }

    var dimStr = formatDimPair(d.width, d.height);

    var rows = [
      ['ITEM NUMBER:',         dash(sku)],
      ['TITLE:',               dash(productTitle)]
    ];

    if (includePricing && pricingData && pricingData.available && pricingData.total) {
      rows.push(['PRICE:', pricingData.total.value || '\u2014']);
    }

    rows.push(
      ['SUBSTRATE:',           dash(d.substrate)],
      ['TREATMENT:',           dash(d.treatment)],
      ['IMAGE SIZE (W\xD7H):', dimStr],
      ['GLASS SIZE:',          formatComputedDim(window.computeGlassSizeInches)],
      ['OUTSIDE DIMENSIONS:', formatComputedDim(window.computeOverallSizeInches)],
      ['FRAME:',               dash(d.frame)],
      ['TOP MAT:',             dash(d.topMat)]
    );

    if (d.bottomMat && d.bottomMat.trim()) {
      rows.push(['BOTTOM MAT:', dash(d.bottomMat)]);
    }

    rows.push(['LINER:', dash(d.liner)]);

    if (d.artworkColor && d.artworkColor.trim()) {
      rows.push(['OTHER:', dash(d.artworkColor)]);
    }
    if (d.customerNotes && d.customerNotes.trim()) {
      rows.push(['CUSTOMER NOTES:', dash(d.customerNotes)]);
    }
    if (d.imageText && d.imageText.trim()) {
      rows.push(['IMAGE TEXT:', dash(d.imageText)]);
    }
    if (d.colorInstruction && d.colorInstruction.trim()) {
      rows.push(['COLOR NOTES:', dash(d.colorInstruction)]);
    }
    if (d.sideMark) {
      rows.push(['SIDE MARK:', d.sideMarkText && d.sideMarkText.trim() ? d.sideMarkText : 'Enabled']);
    }

    function drawSpecRow(label, value) {
      if (sy > PH - 16) return;
      doc.setFontSize(7.5);
      doc.setFont(undefined, 'bold'); setTxt(BLACK);
      doc.text(label, lbX, sy);
      doc.setFont(undefined, 'normal'); setTxt(BLACK);
      var lines = doc.splitTextToSize(String(value), valueMaxW);
      doc.text(lines, vX, sy);
      sy += rowH * Math.max(1, lines.length);
    }

    rows.forEach(function (row) {
      drawSpecRow(row[0], row[1]);
    });

    /* Divider + description */
    if (sy < PH - 18) {
      sy += 3;
      setDraw(LGREY); doc.line(rx, sy, rx + rw, sy); sy += 6;
      var descParts = [];
      if (d.substrate) descParts.push(d.substrate);
      if (d.treatment) descParts.push(d.treatment);
      if (d.frame) descParts.push('Frame: ' + d.frame);
      if (d.topMat) descParts.push('Top Mat: ' + d.topMat);
      if (d.liner) descParts.push('Liner: ' + d.liner);
      if (descParts.length) {
        drawSpecRow('DESCRIPTION:', descParts.join(', '));
      }
    }

    /* ── FOOTER ── */
    var fy = PH - 10;
    setDraw(LGREY); doc.line(margin, fy - 4, PW - margin, fy - 4);
    doc.setFontSize(7); setTxt(GREY); doc.setFont(undefined, 'normal');
    doc.text('ICONIC PINEAPPLE  \u2022  iconicpineapple.com', margin, fy);
    doc.text(websiteUrl, PW - margin, fy, { align: 'right' });

    /* ── SAVE ── */
    var fileStem = (String(productTitle).replace(/\s+/g, '_') || 'product') + '_tear_sheet';
    if (includePricing && pricingData && pricingData.available) {
      fileStem += '_with_pricing';
    }
    doc.save(fileStem + '.pdf');
  }

  window.generateTearSheet = generateTearSheet;

  function closeTearSheetMenus(exceptWrap) {
    document.querySelectorAll('.summary-tearsheet-actions--open').forEach(function (wrap) {
      if (exceptWrap && wrap === exceptWrap) return;
      wrap.classList.remove('summary-tearsheet-actions--open');
      var trigger = wrap.querySelector('.summary-tearsheet-trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function bindTearSheetMenus() {
    if (window.__tearSheetMenuBound) return;
    window.__tearSheetMenuBound = true;

    document.addEventListener('click', function (e) {
      var opt = e.target.closest('.summary-tearsheet-option');
      if (opt) {
        e.preventDefault();
        e.stopPropagation();
        closeTearSheetMenus();
        generateTearSheet(opt.getAttribute('data-tearsheet-pricing') === '1');
        return;
      }

      var trigger = e.target.closest('.summary-tearsheet-trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = trigger.closest('.summary-tearsheet-actions');
        if (!wrap) return;
        var isOpen = wrap.classList.contains('summary-tearsheet-actions--open');
        closeTearSheetMenus();
        if (!isOpen) {
          wrap.classList.add('summary-tearsheet-actions--open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      if (!e.target.closest('.summary-tearsheet-actions')) {
        closeTearSheetMenus();
      }
    });
  }

  /* ============================================================
    INIT — single delegated tear-sheet click handler
    (Bound only once per page, regardless of patch re-execution.)
    ============================================================ */
  function runPatches() {
    if (window.__customizerPatchInited) return;
    window.__customizerPatchInited = true;

    patchViewInRoom();
    bindTearSheetMenus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPatches);
  } else {
    runPatches(); 
  }
  